import React, { useState } from "react";
import { FormControl, FormLabel, HStack, Input } from "@chakra-ui/react";
import { FormLabelStyle } from "../../styles";
import { NumberInput } from "../NumberInput/NumberInput";
export const ColorPicker = ({ id, color, label, onChange, }) => {
    const [colorState, setColorState] = useState(color);
    return (React.createElement(FormControl, null,
        label ? (React.createElement(FormLabel, Object.assign({ htmlFor: id }, FormLabelStyle), label)) : (React.createElement(React.Fragment, null)),
        React.createElement(HStack, null,
            React.createElement(Input, { size: "sm", id: id, type: "color", defaultValue: color.substring(0, 7), onChange: (e) => {
                    setColorState(`${e.currentTarget.value}${color.substring(7, 9)}`);
                    onChange(`${e.currentTarget.value}${color.substring(7, 9)}`);
                } }),
            React.createElement(NumberInput, { id: "text-color-alpha", defaultValue: Math.round(parseInt(color.substring(7, 9), 16) / 2.55) || 100, onChange: (_, value) => {
                    const hexValue = Math.round(value * 2.55).toString(16);
                    setColorState(`${colorState.substring(0, 7)}${hexValue.length === 2 ? hexValue : `0${hexValue}`}`);
                    onChange(`${colorState.substring(0, 7)}${hexValue.length === 2 ? hexValue : `0${hexValue}`}`);
                } }))));
};
